<template>
    <Breadcrumbs main="Apps" title="Bookmarks" />
    <div class="container-fluid">
        <div class="email-wrap bookmark-wrap">
            <div class="row">
                <bookmarkSidebar />
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'

const bookmarkSidebar = defineAsyncComponent(() => import("@/components/theme/bookmark/bookmarkSidebar.vue"))

</script>